/**
 * UFD theme behaviours.
 * Ported from the prototype (src/js/main.js), minus:
 *   - partial injection  (Liquid renders the chrome server-side)
 *   - the mock cart      (Spotlight owns the real cart / Cart AJAX API)
 *
 * Cart count is kept live from /cart.js so quick-adds elsewhere still update
 * the header badge.
 */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var menu = document.querySelector('[data-menu]');
    if (!menu) return;
    var open = function () { menu.dataset.open = 'true'; document.body.style.overflow = 'hidden'; };
    var close = function () { menu.dataset.open = 'false'; document.body.style.overflow = ''; };
    var btn = document.querySelector('[data-menu-open]');
    var closeBtn = document.querySelector('[data-menu-close]');
    if (btn) btn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    /* Rotating past the desktop breakpoint must close the overlay AND release the scroll lock. */
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && menu.dataset.open === 'true') close();
    });
  }

  /* ---------- Option groups (variant swatches, thumbs, filters) ---------- */
  function selectInGroup(group, btn) {
    group.querySelectorAll('.opt, .chip, .pdp__thumb').forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-selected', 'false');
    });
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('aria-selected', 'true');
  }

  function initToggleGroups() {
    document.querySelectorAll('[data-opt-group]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.opt, .chip, .pdp__thumb');
        if (!btn || !group.contains(btn)) return;
        selectInGroup(group, btn);

        var kind = group.dataset.optKind;
        var value = btn.dataset.value;

        var src = btn.dataset.img || (btn.classList.contains('pdp__thumb') && btn.querySelector('img') ? btn.querySelector('img').src : null);
        var stage = document.querySelector('[data-pdp-stage] img');
        if (stage && src) {
          /* The stage img carries srcset; browsers ignore `src` while srcset is
             present, so the swap MUST update srcset too (or remove it). */
          if (btn.dataset.srcset) stage.srcset = btn.dataset.srcset;
          else stage.removeAttribute('srcset');
          stage.src = src;
        }

        if (kind && value) {
          document.querySelectorAll('[data-opt-value-for="' + kind + '"]').forEach(function (el) { el.textContent = value; });
          document.querySelectorAll('[data-opt-kind="' + kind + '"]').forEach(function (other) {
            if (other === group) return;
            var twin = other.querySelector('[data-value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
            if (twin) selectInGroup(other, twin);
          });
        }
      });
    });
  }

  /* ---------- Collection filters ----------
     Multi-axis engine: type (data-filter buttons over data-cat, substring match,
     'all' shows everything), color (multi-select swatches), price range (dual
     slider + number fields) and sort (reorders cards with appendChild -
     'featured' restores original DOM order). Sidebar hooks are all optional:
     a bare data-filter-bar (e.g. homepage chips) still works standalone. */
  function initFilters() {
    var bar = document.querySelector('[data-filter-bar]');
    if (!bar) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-cat]'));
    if (!cards.length) return;
    var grid = cards[0].parentElement;
    var original = cards.slice();
    var priceOf = function (c) { return parseInt(c.dataset.price || '0', 10); };
    var state = { cats: {}, catCount: 0, colors: {}, colorCount: 0, min: -Infinity, max: Infinity, sort: 'featured' };

    var apply = function () {
      var order = original.slice();
      if (state.sort === 'price-asc') order.sort(function (a, b) { return priceOf(a) - priceOf(b); });
      if (state.sort === 'price-desc') order.sort(function (a, b) { return priceOf(b) - priceOf(a); });
      if (state.sort === 'new') order.sort(function (a, b) { return (+b.dataset.created || 0) - (+a.dataset.created || 0); });
      order.forEach(function (c) { grid.appendChild(c); });

      var shown = 0;
      original.forEach(function (card) {
        var catOk = !state.catCount || Object.keys(state.cats).some(function (f) { return (card.dataset.cat || '').indexOf(f) !== -1; });
        var dollars = priceOf(card) / 100;
        var priceOk = dollars >= state.min && dollars <= state.max;
        var cardColors = (card.dataset.color || '').split('|').filter(Boolean);
        var colorOk = !state.colorCount || cardColors.some(function (c) { return state.colors[c]; });
        var show = catOk && priceOk && colorOk;
        card.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      document.querySelectorAll('[data-shop-count]').forEach(function (el) {
        el.textContent = shown + (shown === 1 ? ' item' : ' items');
      });
    };

    /* Type: multi-select checkboxes; 'all' clears every check. */
    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]');
      if (!chip) return;
      var f = chip.dataset.filter;
      if (f === 'all') { state.cats = {}; state.catCount = 0; }
      else if (state.cats[f]) { delete state.cats[f]; state.catCount--; }
      else { state.cats[f] = true; state.catCount++; }
      bar.querySelectorAll('[data-filter]').forEach(function (b) {
        var v = b.dataset.filter;
        b.setAttribute('aria-pressed', String(v === 'all' ? state.catCount === 0 : !!state.cats[v]));
      });
      apply();
    });

    var sortGroup = document.querySelector('[data-sort-group]');
    if (sortGroup) sortGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sort]');
      if (!btn) return;
      sortGroup.querySelectorAll('[data-sort]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      state.sort = btn.dataset.sort;
      apply();
    });

    var colorGroup = document.querySelector('[data-color-group]');
    if (colorGroup) colorGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-color-filter]');
      if (!btn) return;
      var val = btn.dataset.colorFilter;
      var on = !!state.colors[val];
      if (on) { delete state.colors[val]; state.colorCount--; } else { state.colors[val] = true; state.colorCount++; }
      btn.setAttribute('aria-pressed', String(!on));
      apply();
    });

    var rangeWrap = document.querySelector('[data-price-range]');
    var sMin = document.querySelector('[data-price-slider="min"]');
    var sMax = document.querySelector('[data-price-slider="max"]');
    var nMin = document.querySelector('[data-price-input="min"]');
    var nMax = document.querySelector('[data-price-input="max"]');
    var fill = document.querySelector('[data-range-fill]');
    if (rangeWrap && sMin && sMax && nMin && nMax) {
      var prices = original.map(function (c) { return priceOf(c) / 100; }).filter(function (p) { return p > 0; });
      var lo = Math.floor(Math.min.apply(null, prices.concat([0])));
      var hi = Math.ceil(Math.max.apply(null, prices.concat([1])));
      [sMin, sMax].forEach(function (s) { s.min = lo; s.max = hi; s.step = 1; });
      sMin.value = lo; sMax.value = hi;
      nMin.value = lo; nMax.value = hi;
      nMin.placeholder = lo; nMax.placeholder = hi;
      state.min = lo; state.max = hi;

      var paint = function () {
        if (!fill) return;
        var span = (hi - lo) || 1;
        var a = ((state.min - lo) / span) * 100;
        var b = ((state.max - lo) / span) * 100;
        fill.style.left = a + '%';
        fill.style.width = Math.max(0, b - a) + '%';
      };
      var setRange = function (min, max, from) {
        min = Math.max(lo, Math.min(hi, isNaN(min) ? lo : min));
        max = Math.max(lo, Math.min(hi, isNaN(max) ? hi : max));
        if (min > max) { if (from === 'min') { max = min; } else { min = max; } }
        state.min = min; state.max = max;
        sMin.value = min; sMax.value = max;
        if (document.activeElement !== nMin) nMin.value = min;
        if (document.activeElement !== nMax) nMax.value = max;
        paint();
        apply();
      };
      sMin.addEventListener('input', function () { setRange(+sMin.value, state.max, 'min'); });
      sMax.addEventListener('input', function () { setRange(state.min, +sMax.value, 'max'); });
      nMin.addEventListener('input', function () { setRange(parseInt(nMin.value, 10), state.max, 'min'); });
      nMax.addEventListener('input', function () { setRange(state.min, parseInt(nMax.value, 10), 'max'); });
      paint();
    }

    /* Mobile: the sidebar collapses behind "Filter & Sort"; desktop keeps it open. */
    var outer = document.querySelector('[data-filters-outer]');
    if (outer) {
      var syncOpen = function () { if (window.innerWidth > 900) outer.open = true; };
      syncOpen();
      window.addEventListener('resize', syncOpen);
    }

    apply();
  }

  /* ---------- Drop countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var slot = function (k) { return el.querySelector('[data-cd="' + k + '"]'); };
      var tick = function () {
        var diff = Math.max(0, target - Date.now());
        var parts = {
          d: Math.floor(diff / 86400000),
          h: Math.floor(diff / 3600000) % 24,
          m: Math.floor(diff / 60000) % 60,
          s: Math.floor(diff / 1000) % 60
        };
        Object.keys(parts).forEach(function (k) {
          var n = slot(k); if (n) n.textContent = pad(parts[k]);
        });
        if (diff === 0) el.setAttribute('data-elapsed', 'true');
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Notify-me (visual; wire to a back-in-stock app later) ---------- */
  function initNotify() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-notify]');
      if (!btn || btn.dataset.done === 'true') return;
      e.preventDefault();
      btn.dataset.done = 'true';
      btn.textContent = '✓ On the list';
      btn.style.borderColor = 'var(--hazard)';
      btn.style.color = 'var(--hazard)';
    });
  }

  /* ---------- PDP variant resolution ----------
     The product section embeds <script type="application/json" data-variant-json>
     with [{id, available, options:[...], price, compare, img}] (prices pre-
     formatted server-side). Option groups carry data-opt-kind="option1|2|3".
     Runs on document (bubble phase) so the group toggle handler has already
     updated aria-pressed state by the time we read it. */
  function initVariantResolver() {
    var root = document.querySelector('[data-product-root]');
    var jsonEl = root && root.querySelector('[data-variant-json]');
    if (!root || !jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var resolve = function () {
      var chosen = [];
      root.querySelectorAll('[data-opt-group][data-opt-kind^="option"]').forEach(function (group) {
        var idx = parseInt(group.dataset.optKind.replace('option', ''), 10) - 1;
        var sel = group.querySelector('[aria-pressed="true"][data-value], [aria-selected="true"][data-value]');
        if (sel) chosen[idx] = sel.dataset.value;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return chosen[i] === undefined || opt === chosen[i]; });
      });
      if (!match) return;

      var idInput = root.querySelector('form [name="id"]');
      if (idInput) idInput.value = match.id;

      var priceEl = root.querySelector('[data-pdp-price]');
      if (priceEl) priceEl.textContent = match.price;

      var addBtn = root.querySelector('[data-pdp-add]');
      if (addBtn) {
        if (addBtn.dataset.soon !== undefined) {
          // Coming Soon drop (D21): never purchasable regardless of what the
          // (possibly cached) variant JSON claims - keep the release label.
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelSoldout || 'Coming Soon';
        } else {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? (addBtn.dataset.labelAdd || 'Add to cart ▸') : (addBtn.dataset.labelSoldout || 'Sold out');
        }
      }
      var stage = root.querySelector('[data-pdp-stage] img');
      if (stage && match.img) {
        stage.removeAttribute('srcset'); /* srcset would override the swapped src */
        stage.src = match.img;
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-opt-group]') && root.contains(e.target)) {
        setTimeout(resolve, 0);
      }
    });
    resolve();
  }

  /* ---------- Live cart count from the real cart ---------- */
  function refreshCartCount() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* non-fatal */ });
  }

  function initCartSync() {
    // Spotlight dispatches/uses fetch for cart updates; re-sync after any add.
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.getAttribute('action') && e.target.getAttribute('action').indexOf('/cart/add') !== -1) {
        setTimeout(refreshCartCount, 600);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[name="add"], .quick-add__submit, [data-add-to-cart]')) {
        setTimeout(refreshCartCount, 800);
      }
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.product-card, .pillar, .rank, .post-card');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'none';
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
      io.observe(el);
    });
  }

  function boot() {
    initMenu();
    initToggleGroups();
    initVariantResolver();
    initFilters();
    initCountdown();
    initNotify();
    initCartSync();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
